module.exports = __webpack_public_path__ + "27ea6e6eeea325e02effb00bd7734624.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/left-ear.png
// module id = 604
// module chunks = 0